import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

const Seminarangebot = ({ blok }) => {
  return (
    <div className="wrap">
      <div
        className="seminarangebot inner-wrap flex flex-col"
        {...storyblokEditable(blok)}
      >
        <h2 className="seminarangebot-headline">{blok.headline}</h2>
        <div className="seminarangebot-content">
          {blok.offer.map((nestedBlok) => (
            <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Seminarangebot;
